import { useState } from "react";
import { useLocation } from "wouter";
import { UrlPaths } from "../../utilities/types";

export default function usePostNewTrust() {
  const [, setLocation] = useLocation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const submitTrust = async (trustsData: any) => {
    const url = "https://hometrustapi.azurewebsites.net/api/v2/Trusts";

    trustsData["dateCreated"] = new Date();
    trustsData["createdBy"] = localStorage.getItem("role"); // TODO change this to name later

    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(url, {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        method: "POST",
        body: JSON.stringify(trustsData),
      });

      if (!response.ok) {
        throw new Error("Server returned error code: " + response.status);
      }
    } catch (error: any) {
      setError(error);
      setIsLoading(false);
    }
    setIsLoading(false);
    setLocation(UrlPaths.Trusts);
  };

  return { submitTrust, isLoading, error };
}
